import Rodape from "../../components/rodape";
import BannerProjects from "../../components/bannerProjects";
import BusinessOtimize from "../../components/businessOtimize";
import AccordionInnovation from "../../components/accordionInnovation";
import ErpMarcas from "../../components/erpMarcas";
import ComoFazemos from "../../components/comoFazemos";

function Advisor() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-advisor.png"
                title="/ADVISOR"
                titleBold=""
                iconSrc="../assets/icone-projectiva-omnicore.png"
                iconAlt="Projectiva Omnicore"
                iconText="omni"
                iconTextBold="core"
                descriptionBold=""
                description={
                    <>
                        Somos{" "}
                        <span className="font-titillium-web-bold">
                            consultores
                        </span>{" "}
                        de confiança que auxiliam seus clientes a tomar{" "}
                        <span className="font-titillium-web-bold">
                            decisões estratégicas
                        </span>{" "}
                        e alcançar resultados excepcionais. Oferecemos{" "}
                        <span className="font-titillium-web-bold">suporte</span>{" "}
                        desde a elaboração de RFPs (Requests for Proposal) até a
                        escolha e implementação da{" "}
                        <span className="font-titillium-web-bold">
                            solução ideal.
                        </span>
                    </>
                }
                footerText="VERTICAL SOLUTIONS | ERP"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]"
                brand="omnicore"
            />
            <ComoFazemos
                title={
                    <>
                        Como{" "}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                            fazemos?
                        </span>
                    </>
                }
                cards={[
                    {
                        icon: "/assets/servicos/abordagem2_icon.svg",
                        iconHover: "/assets/servicos/abordagem2_icon.svg",
                        title: "Abordagem",
                        text: (
                            <>
                                <p>
                                    Nossa atuação é independente, técnica e
                                    totalmente orientada ao negócio.
                                </p>
                                <p className="mt-2">
                                    Assumimos o papel de advisor com visão
                                    crítica e agnóstica, apoiando o cliente
                                    desde a análise do cenário atual até a
                                    definição da estratégia mais eficiente sem
                                    empurrar soluções prontas.
                                </p>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "410",
                    },
                    {
                        icon: "/assets/servicos/foco_icon.svg",
                        iconHover: "/assets/servicos/foco_icon.svg",
                        title: "Foco",
                        text: (
                            <>
                                <p>
                                    Focamos em tomada de decisão com base em
                                    dados, contexto e objetivo real.
                                </p>
                                <p className="mt-2">
                                    Apoiamos desde a elaboração de RFPs até
                                    comparativos de fornecedores, avaliação de
                                    riscos, aderência funcional e definição de
                                    roadmap.
                                </p>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "410",
                    },
                    {
                        icon: "/assets/servicos/entrega_icon.svg",
                        iconHover: "/assets/servicos/entrega_icon.svg",
                        title: "Entrega",
                        text: (
                            <>
                                <p>
                                    Entregamos clareza e segurança para decisões
                                    estratégicas sobre ERP, seja em projetos de
                                    migração, reimplementação, expansão ou
                                    modernização.
                                </p>
                                <p className="mt-2">
                                    Com atuação próxima das lideranças,
                                    traduzimos complexidade técnica em caminhos
                                    objetivos e sustentáveis.
                                </p>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "410",
                    },
                ]}
            />
            <ErpMarcas />
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold">
                            Somos o parceiro estratégico
                        </span>{" "}
                        no
                        <br />
                        desenvolvimento de soluções em inovação.
                    </>
                }
                buttonText="Otimize seu negócio!"
                backgroundImage="../assets/banner-erp-otimize.png"
                buttonLink="/"
            />
            <AccordionInnovation
                title=""
                description=""
                imageSrc="/assets/entregas-advisor.png"
                imageAlt="Entregas Advisor"
                origem="solutions"
                items={[
                    {
                        id: "01",
                        title: "ANÁLISE E DIAGNÓSTICO INICIAL",
                        description:
                            "Realizamos avaliações profundas das necessidades e objetivos estratégicos do negócio, identificando requisitos específicos e detectando lacunas nos processos atuais, para garantir que a nova solução ERP traga valor tangível e impacto real.",
                    },
                    {
                        id: "02",
                        title: "PREPARAÇÃO DE RFP (REQUEST FOR PROPOSAL)",
                        description:
                            "Desenvolvemos RFPs detalhadas e personalizadas adequadas às necessidades do cliente. Definimos critérios para seleção de fornecedores e prestamos suporte contínuo para otimizar as respostas dos fornecedores.",
                    },
                    {
                        id: "03",
                        title: "SELEÇÃO E AVALIAÇÃO DE FORNECEDORES",
                        description:
                            "Analisamos propostas dos fornecedores, considerando: custo, funcionalidade, escalabilidade e suporte. Avaliamos demonstrações e provas de conceito para assegurar que os requisitos do cliente foram atendidos",
                    },
                    {
                        id: "04",
                        title: "PLANEJAMENTO E IMPLANTAÇÃO DE ERP",
                        description:
                            "Elaboramos o design da solução ERP, alinhado aos objetivos do negócio. Gerenciamos todas as fases do projeto, para otimizar prazos e orçamentos e assegurar a customização e integração perfeita com os sistemas legados",
                    },
                    {
                        id: "05",
                        title: "TREINAMENTO E SUPORTE CONTÍNUO",
                        description:
                            "Disponibilizamos treinamento completo para capacitação de equipe no cliente, para o uso do ERP. Após a implementação, oferecemos suporte contínuo para solucionar problemas e adaptar a solução de acordo com a necessidade.",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default Advisor;
